import { render } from "./editText.vue?vue&type=template&id=f3624caa"
import script from "./editText.vue?vue&type=script&lang=js"
export * from "./editText.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__